import { setTheme } from "theme/default/setTheme";

export const color_e7ecf2 = setTheme(({ theme }) => theme.colors.color_e7ecf2);
